import { t } from "../core/i18n.js";
import { icon } from "./icons.js";

// Public examples are independent of every user's saved routines.
export const planExamples = [
  { key: "wake", name: "Wake up early", schedule: "06:30", glyph: "clock" },
  {
    key: "run",
    name: "Go for a run",
    schedule: "07:00 — 07:30",
    glyph: "spark",
  },
  {
    key: "work",
    name: "Focus on important work",
    schedule: "09:00 — 11:00",
    glyph: "dashboard",
  },
  {
    key: "learn",
    name: "Learn something new",
    schedule: "18:00 — 18:30",
    glyph: "exams",
  },
  {
    key: "family",
    name: "Spend time with family",
    schedule: "19:00 — 20:00",
    glyph: "all",
  },
  {
    key: "tomorrow",
    name: "Plan tomorrow",
    schedule: "21:00 — 21:10",
    glyph: "weekly",
  },
];

export function hasExample(tasks, example) {
  return tasks.some((task) =>
    task.id.startsWith(`plan_example_${example.key}_`),
  );
}

export function renderPlanExamples(tasks, open) {
  const remaining = planExamples.filter(
    (example) => !hasExample(tasks, example),
  );
  return `<details class="planning-examples" ${open ? "open" : ""}><summary>${icon("spark")}<span>${t("Everyday plan ideas")}</span><small>${t("6 examples")}</small>${icon("chevron")}</summary><div class="planning-examples-body"><p>${t("Choose an example, or write your own. Times are editable.")}</p><div class="planning-example-grid">${planExamples
    .map((example) => {
      const added = hasExample(tasks, example);
      return `<button type="button" class="planning-example ${added ? "added" : ""}" data-add-example="${example.key}" ${added || tasks.length >= 1000 ? "disabled" : ""} aria-label="${t(added ? "{name} added" : "Add {name}", { name: t(example.name) })}"><span class="planning-example-icon">${icon(example.glyph)}</span><span><strong>${t(example.name)}</strong><small>${example.schedule}</small></span><span class="planning-example-action">${icon(added ? "check" : "plus")}</span></button>`;
    })
    .join(
      "",
    )}</div><button type="button" class="planning-text-button" data-add-all-examples ${!remaining.length || tasks.length >= 1000 ? "disabled" : ""}>${icon("plus")}${t(remaining.length ? "Add all examples" : "All examples added")}</button></div></details>`;
}

export function exampleBulkPlaceholder() {
  return planExamples
    .map((example) => `${example.schedule.slice(0, 5)} ${t(example.name)}`)
    .join("\n");
}
